import React from "react";
import { Dropdown, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import icGlobe from './../assets/svg/ic_globe.svg';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';

const DropdownLang = ({className}) => {
  const { i18n } = useTranslation();
  const locale = localStorage.getItem('locale');
  const selected = locale ? JSON.parse(locale) : { lng: 'tk', code: 'TM'}; 
  const [key, setKey] = React.useState(0); // State to trigger re-render

  const languages = [
    {lng: 'tk', code: 'TM'},
    {lng: 'ru', code: 'RU'},
    {lng: 'en', code: 'EN'},
  ]

  const changeLanguage = (lng, code) => {
      i18n.changeLanguage(lng);
      const locale = {lng, code};
      localStorage.setItem('locale', JSON.stringify(locale));
      setKey(prevKey => prevKey + 1); // Force update
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div className={`bg-light rounded-4 px-2 py-1 hover-cursor me-3 ${className}`}
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}>
      <img src={icGlobe} className="wh-15" />
      <span className="font-14 fg-dark bold hide-tag-level-2 ms-1">{selected.code}</span>
      <ExpandMoreOutlinedIcon className="font-16 ms-1 fg-gray hide-tag-level-2"/>
    </div>
  ));

  return (
    <Dropdown className="large" key={key}>
      <Dropdown.Toggle as={CustomToggle}/>
      <Dropdown.Menu className="bg-light" style={{ minWidth: '120px' }}>
        <Nav className="d-flex flex-row align-items-center">
          {languages.map((lang) => {
            return (
              <Nav.Link key={lang.lng} onClick={() => changeLanguage(lang.lng, lang.code)} className={`bold ms-1 small py-0 px-2 ${lang.code == selected.code ? 'bg-primary text-white rounded-1' : 'lang-item'}`}>{lang.code}</Nav.Link>
            )
          })}
        </Nav>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default DropdownLang;